export function getSearchUrl(text: string, brand: string, useAnalogs: boolean): string {
    return `/search?text=${text}&brand=${encodeURIComponent(brand)}&useAnalogs=${useAnalogs}`;
}